// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  packagesManagerBackendUrl: 'http://localhost:8080/api',
  domainUrl: 'http://localhost:8080',
  basicAuthLogout: 'http://localhost:4200',
  xApiKey: 'bentley-drivers-guide',
  xApiSecret: 'wr7d34X&UX2Zf%Y8'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
